<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/IT/banner.png" alt="" />
    </div>
    <!-- 内容提示 -->
    <!-- <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 > 新闻动态 > 新闻</span>
      </div>
    </div> -->
    <!-- 整体内容 -->
    <div class="main">
      <!-- 标题  -->
      <div class="main-title">业务服务范围</div>
      <div class="main-line"></div>
      <!-- 咨询服务 -->
      <div class="flex">
        <div class="left">
          <img src="../assets/IT/zxfw.png" alt="" />
        </div>
        <div class="right">
          <div class="title">咨询服务</div>
          <div class="introduction">
            雅格科技利用自身累积的技术优势，给金融客户赋能，提供包括IT规划咨询、
            业务和管理咨询、商业化软件实施咨询、人力派遣咨询等，帮助客户实现数字化转
            型。通过专业的技术专家团队，为客户提供标准的技术开发服务，通过自身不断的
            技术打磨，帮助客户节约成本，完善IT建设，最终实现数字化。
          </div>
        </div>
      </div>

      <!-- 技术开发服务 -->
      <div class="flex">
        <div class="left">
          <img src="../assets/IT/jskffw.png" alt="" />
        </div>
        <div class="right">
          <div class="title">技术开发服务</div>
          <div class="introduction">
            雅格能为金融客户提供多元化技术、跨平台支撑、多地域支持、全生命周期的技术开发服务。
          </div>
        </div>
      </div>
      <!-- 测试服务 -->
      <div class="flex">
        <div class="left">
          <img src="../assets/IT/csfw.png" alt="" />
        </div>
        <div class="right">
          <div class="title">测试服务</div>
          <div class="introduction">
           雅格测试服务致力于不断提高应用系统质量，把控系统的稳定性、可用性和用户体验，
           控制项目成本与风险，打造高可控、高稳定性、兼顾效益的系统工程。
          </div>
        </div>
      </div>
      <!-- 运维服务 -->
      <div class="flex">
        <div class="left">
          <img src="../assets/IT/ywfw.png" alt="" />
        </div>
        <div class="right">
          <div class="title">运维服务</div>
          <div class="introduction">
          雅格利用自身技术优势，提供数据中心运维、终端软硬件运维等一系列运维服务，
          降低客户的运营维护成本，提高经营效率，并降低经营风险
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottom">
        <img class="bot-background" src="../assets/IT/bottom.png" alt="" />
        <img class="bot-button" src="../assets/IT/btn.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;
  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    img {
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .main {
    width: 100%;
    background: #f5f5fa;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405c80;
    padding: 40px 0;
    box-sizing: border-box;
    text-align: center;
    // it服务标题
    .main-title {
      font-size: 35px;
      color: #4d4d4d;
    }
    .main-line {
      width: 106px;
      height: 4px;
      background: linear-gradient(
        -90deg,
        rgba(0, 204, 255, 0.95),
        rgba(0, 61, 230, 0.95)
      );
      border-radius: 3px;
      margin: 10px auto 60px;
    }
    // it服务介绍
    .flex {
      width: 76%;
      margin: 0 12% 40px;
      display: flex;
      text-align: left;
      .left {
        img {
          height: 200px;
          width: auto;
        }
      }
      // 标题
      .title {
        font-size: 23px;
        color: #135de4;
        margin: 10px 20px;
        cursor: pointer;
      }
      // 内容介绍
      .introduction {
        font-size: 16px;
        color: #808080;
        margin: 40px 20px 0;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
    }
    // 底部
    .bottom {
      width: 76%;
      margin: 20px 12%;
      position: relative;
      .bot-background {
        width: 100%;
        height: auto;
      }
      .bot-button {
        position: absolute;
        bottom: 32%;
        width: 13%;
        left: 42%;
      }
    }
  }
}
</style>
